import type { VersionString, ViewID } from "@bestowinc/tinkertoy-core";

import { startPerformanceTimer } from "./timers";
import type { PerformanceTimer } from "./timers";
import { PERFORMANCE_METRIC_NAMES } from "./types";

let activeTimer: PerformanceTimer | null = null;
let activeView: { viewId: ViewID; viewVersion: VersionString } | null = null;

export function beginRevalidationTracking(args: {
  viewId: ViewID;
  viewVersion: VersionString;
}): void {
  activeTimer?.cancel();
  activeTimer = startPerformanceTimer(PERFORMANCE_METRIC_NAMES.revalidation, {
    viewId: args.viewId,
    viewVersion: args.viewVersion,
  });
  activeView = args;
}

export function completeRevalidationTracking(): void {
  if (!activeTimer) {
    return;
  }
  activeTimer.complete("success");
  activeTimer = null;
  activeView = null;
}

export function cancelRevalidationTracking(): void {
  activeTimer?.cancel();
  activeTimer = null;
  activeView = null;
}

export function getActiveRevalidationView(): {
  viewId: ViewID;
  viewVersion: VersionString;
} | null {
  return activeView;
}
